<template>
  <div class="upload-img" :style="`width: ${width}px`"> 
    <el-upload :limit="1" action=""
      :on-change="onUploadChange"
      :auto-upload="false"
      :file-list="fileList"
      list-type="picture-card"
      :on-preview="handlePictureCardPreview"
      :on-remove="handleRemove"
      :class="{'hide-add': hideAdd}"
      :disabled="disabled">
      <i class="el-icon-plus"></i>
    </el-upload>
    <div slot="tip" class="desc" v-if="content" v-html="content"></div>
    <el-dialog :visible.sync="dialogVisible">
      <img class="img-plus" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import pdfReplace from '@/assets/img/pdf.png';
import { getImageUrl,uploadImage } from "@/http/upload.js";
import { getFile } from '@/http/api.js'
export default {
  name: 'UploadImg',
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      imgBase64: '', // base64编码
      isUploading: false,
      fileList: [],
      url: '',
      fileType: ''
    };
  },
  props: {
    needAdd: {
      type: Boolean,
      default: true
    },
    isLogin: { // 默认登录
      type: Boolean,
      default: true
    },
    content: String,
    imgId: String,
    name: String, // 图片名称，同时有多张图片时传入区分不同的图片
    disabled: {
      type: Boolean,
      default: false
    },
    width: String
  },
  computed: {
    hideAdd() {
      return this.fileList.length >= 1
    }
  },
  watch: {
    imgId(val) {
      if(val) {
        this.handleFile()
      }
    }
  },
  methods: {
    handleFile() {
      getFile(`/bds/publicrs/image/${ this.imgId }`).then(res => {
        this.fileType = res.type
        const url = res.type == 'application/pdf' ? pdfReplace : getImageUrl(this.imgId, this.isLogin)
        this.fileList = [{name: this.name, url} ];
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.$emit('delete', this.name)
    },
    handlePictureCardPreview(file) {
      console.log('fiel',file)
      if(this.fileType == 'application/pdf') {
        this.viewPdf()
      } else {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      }
    },
    viewPdf() {
      const url = getImageUrl(this.imgId, this.isLogin)
      const link = document.createElement('a');
      link.style.display = 'none'
      link.href = url;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    onUploadChange (file, fileList) {
      const isLt1M = file.size / 1024 / 1024 < 20;
      if (!isLt1M) {
        this.fileList = []
        this.$message.error('上传文件大小不能超过 20MB!');
        return false;
      }
      const v = this
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = e => {
          // 通过get-img向父组建传递图片的base64编码和fileId（多张图片时标识图片）
        this.isUploading = true
        uploadImage(file.raw, this.isLogin).then(res => {
              this.isUploading = false
              v.imgBase64 = e.target.result
              v.$emit('get-img', v.imgBase64,v.name, res.data.fileId)
              if (file.raw.type == 'application/pdf') {
                fileList[0].url = pdfReplace
              }
              v.fileList = fileList
            }).catch(err => {
              this.fileList = []
              // v.$message.error(err.msg || err.message);
              console.log(err)
        })
      }
    }
  },
  created() {
    if (this.imgId) {
      this.handleFile()
    }

  }
}
</script>

<style lang="less" scoped>
.upload-img {
  display: flex;
  position: relative;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 73px;
    height: 72px;
  }
  /deep/ .el-upload--picture-card{
    width: 73px;
    height: 72px;
  }
  /deep/ .el-upload--picture-card i {
    display: flex;
    justify-content: center;
    padding-top: 20px;
  }
  .hide-add/deep/ .el-upload--picture-card {
    display: none;
  }
  .desc {
    position: absolute;
    width: 400px;
    color: #707070;
    font-size: 10px;
    line-height: 1.4;
    margin-left: 21px;
    right: -200px;
  }
  /deep/.el-icon-close-tip {
    display: none !important;
  }
}
/deep/ .el-dialog__body {
  text-align: center;
}
.img-plus {
  width: 50%;
  max-height: 100%;
  background-size: auto;
}
</style>
